//********* TUTORIALS *********//
import * as types from "./actionTypes";
import {IS_LOOK_JOURNEY} from "../config";

export const toggleShowAssignQuotePopup = (showAssignQuotePopup, assignQuotePopupSaveButtons = "all") => {
  return (dispatch) => {
    dispatch({
      type: types.TOGGLE_SHOW_ASSIGN_QUOTE_POPUP,
      payload: {showAssignQuotePopup, assignQuotePopupSaveButtons}
    });
    if (IS_LOOK_JOURNEY && document.kvConfig.isBackend) {
      dispatch({
        type: types.SET_LOOK_OVERLAY_OPENED,
        payload: {lookOverlayOpened: false}
      });
    }
  }
};

export const setAssignQuotePopupSearchText = (assignQuotePopupSearchText) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_SEARCH_TEXT,
  payload: {assignQuotePopupSearchText}
});

export const setAssignQuotePopupEmployee = (assignQuotePopupEmployee) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_EMPLOYEE,
  payload: {assignQuotePopupEmployee}
});

export const setAssignQuotePopupCustomer = (assignQuotePopupCustomer) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_CUSTOMER,
  payload: {assignQuotePopupCustomer}
});

export const setAssignQuotePopupSuccessText = (assignQuotePopupSuccessText) => ({
  type: types.SET_ASSIGN_QUOTE_POPUP_SUCCESS_TEXT,
  payload: {assignQuotePopupSuccessText}
});

export const setAssignQuoteCloneMode = (assignQuoteCloneMode) => ({
  type: types.SET_ASSIGN_QUOTE_CLONE_MODE,
  payload: {assignQuoteCloneMode}
});

export const setAssignQuoteOfflineData = (offlineData) => ({
  type: types.SET_ASSIGN_QUOTE_OFFLINE_DATA,
  payload: offlineData
});
